const config = {
  apiKey: "AIzaSyDq0LacdYcsxWTmDpKp1LIaFb2RI70-2xg",
  authDomain: "kthfootprint.firebaseapp.com",
  databaseURL: "https://kthfootprint.firebaseio.com",
  projectId: "kthfootprint",
  storageBucket: "kthfootprint.appspot.com",
  messagingSenderId: "1056144965980",
  appId: "1:1056144965980:web:e717ec63efb8dbab"
};

export default config;
